"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeekStartEnd = exports.getMonthStartEnd = exports.getYearStartEnd = exports.getDiffByTimestamp = exports.setTimezone = exports.setCity = exports.subtract = exports.add = exports.getAddSubtractString = exports.getFormatTimeByBrowserTimezone = exports.getZeroTimeStamp = exports.getDiffTime = exports.endOf = exports.startOf = exports.getTimeStamp = exports.formatSimple = exports.formatInterval = exports.getCapitalCity = exports.formatCountdownTime = exports.formatDateTimeByCityId = exports.formatDateTimeByTimezone = exports.formatDateTime = exports.getFormatTimeByPatternAndTimezone = exports.getFormatTimeByPattern = exports.getUTCTimeStamp = void 0;
var base_1 = require("./base");
var helper_1 = require("../utils/helper");
__exportStar(require("./base"), exports);
var getUTCTimeStamp = function (time, pattern) {
    var _a = (0, base_1.matchTime)(pattern || 'yyyy-MM-dd HH:mm:ss', time), year = _a.year, month = _a.month, day = _a.day, hour = _a.hour, minute = _a.minute, second = _a.second;
    // Date.UTC返回从 1970 年 1 月 1 日 00:00:00 UTC 到指定时间的毫秒数
    var UTC = Date.UTC(year, month, day, hour, minute, second) / 1000;
    return UTC - (0, base_1.getOffset)(UTC - (0, base_1.getOffset)(UTC, (0, base_1.getTimezone)()), (0, base_1.getTimezone)());
};
exports.getUTCTimeStamp = getUTCTimeStamp;
var getFormatTimeByPattern = function (timeStamp, pattern, showOffset) {
    (0, base_1.checkoutTimestamp)(timeStamp);
    var formatDateTimeInfo = new base_1.FormatDateTimeInfo({ timeStamp: timeStamp });
    return formatDateTimeInfo.formatConf().formatStr(pattern, showOffset);
};
exports.getFormatTimeByPattern = getFormatTimeByPattern;
var getFormatTimeByPatternAndTimezone = function (timezone, timeStamp, pattern, showOffset) {
    (0, base_1.checkoutTimestamp)(timeStamp);
    var formatDateTimeInfo = new base_1.FormatDateTimeInfo({ timeStamp: timeStamp, timezone: timezone });
    return formatDateTimeInfo.formatConf().formatStr(pattern, showOffset || false);
};
exports.getFormatTimeByPatternAndTimezone = getFormatTimeByPatternAndTimezone;
var formatDateTime = function (timeStamp, dateStyle, timeStyle, showOffset, options) {
    var _a;
    (0, base_1.checkoutTimestamp)(timeStamp);
    var timezone = (options || {}).timezone;
    var formatDateTimeInfo = new base_1.FormatDateTimeInfo({ timeStamp: timeStamp, timezone: timezone });
    var _b = formatDateTimeInfo
        .formatConf(dateStyle, timeStyle)
        .getFormatConf(), dateFormat = _b.dateFormat, timeFormat = _b.timeFormat, format = _b.format;
    var dateStr = formatDateTimeInfo.formatStr(dateFormat, showOffset);
    var timeStr = formatDateTimeInfo.formatStr(timeFormat, showOffset);
    if (!dateStr && !timeStr)
        return undefined;
    if (!timeFormat)
        return dateStr;
    if (!dateFormat)
        return timeStr;
    return (_a = format.replace('{1}', dateStr).replace('{0}', timeStr)) === null || _a === void 0 ? void 0 : _a.trim();
};
exports.formatDateTime = formatDateTime;
var formatDateTimeByTimezone = function (timezone, timeStamp, dateStyle, timeStyle, showOffset) {
    return (0, exports.formatDateTime)(timeStamp, dateStyle, timeStyle, showOffset || false, { timezone: timezone });
};
exports.formatDateTimeByTimezone = formatDateTimeByTimezone;
var formatDateTimeByCityId = function (cityId, timeStamp, dateStyle, timeStyle, showOffset) {
    var timezone = (0, base_1.getTimezone)(cityId);
    return (0, exports.formatDateTimeByTimezone)(timezone, timeStamp, dateStyle, timeStyle, showOffset);
};
exports.formatDateTimeByCityId = formatDateTimeByCityId;
var formatCountdownTime = function (seconds, isHighlight) {
    if (seconds < 0)
        throw Error('Elvish Error: negative is not valid');
    var duration = (0, base_1.getDuration)(seconds);
    var timeUnits = [
        Math.floor(seconds / 3600 / 24),
        Math.floor((seconds % (3600 * 24)) / 3600),
        Math.floor((seconds % 3600) / 60),
        seconds % 60 // seconds
    ];
    for (var i = 0; i < timeUnits.length; i++) {
        if (timeUnits[i]) {
            var nextUnit = timeUnits[i + 1];
            var replaceValue = isHighlight ? "{".concat(timeUnits[i], "}") : timeUnits[i];
            var replaceNextValue = isHighlight ? "{".concat(nextUnit, "}") : nextUnit;
            // 判断 duration 中占位符是否大于1个，如【{1}天{0}小时】，而不是【{0}分钟】
            var regex = /\{[01]\}/g;
            var matches = duration.match(regex);
            var durationBiggerThanOne = matches && matches.length > 1;
            if (nextUnit) {
                return duration.replace('{1}', replaceValue).replace('{0}', replaceNextValue);
            }
            if (nextUnit === 0 && durationBiggerThanOne) {
                return duration.replace('{1}', replaceValue).replace(/\{0\}(.*)/, '');
            }
            return duration.replace('{0}', replaceValue);
        }
    }
};
exports.formatCountdownTime = formatCountdownTime;
var getCapitalCity = function (country) {
    var _a;
    var countryInfo = (0, base_1.getCountryTimezone)(country);
    return ((_a = countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.timezones) === null || _a === void 0 ? void 0 : _a.find(function (timezone) { return timezone.capital; })) || null;
};
exports.getCapitalCity = getCapitalCity;
// 时间区间的格式化
var formatInterval = function (startTime, endTime, dateStyle, timeStyle) {
    var curStartTime = parseInt(String(startTime), 10);
    var curEndTime = parseInt(String(endTime), 10);
    var validStyles = ['DATE_DD_MM_YYYY', 'DATE_DD_MTH', 'TIME_HH_MM', 'DATE_NONE', 'TIME_NONE'];
    if (curStartTime < 0 || curStartTime > curEndTime) {
        throw Error('Elvish Error: invalid time parameters');
    }
    [dateStyle, timeStyle].forEach(function (style) {
        if (!validStyles.includes(style))
            throw Error("Elvish Error: invalid ".concat(style, " parameters"));
    });
    var startOffsetTime = (0, base_1.getOffsetTime)(curStartTime);
    var endOffsetTime = (0, base_1.getOffsetTime)(curEndTime);
    var pattern = (0, base_1.getIntervalPattern)(startOffsetTime, endOffsetTime, dateStyle, timeStyle);
    var spliter = pattern.match(/\s\W\s/)[0];
    var patternArr = pattern.split(spliter);
    var dateStr1 = (0, exports.getFormatTimeByPattern)(curStartTime, patternArr[0]);
    var dateStr2 = (0, exports.getFormatTimeByPattern)(curEndTime, patternArr[1]);
    return patternArr.length === 2 ? "".concat(dateStr1).concat(spliter).concat(dateStr2) : dateStr1;
};
exports.formatInterval = formatInterval;
var formatSimple = function (timeStamp, style) {
    (0, base_1.checkoutTimestamp)(timeStamp);
    var styleMap = {
        STYLE_YMDHMS: 'yyyy-MM-dd HH:mm:ss',
        STYLE_YMD: 'yyyy-MM-dd'
    };
    var formatDateTimeInfo = new base_1.FormatDateTimeInfo({ timeStamp: timeStamp });
    return formatDateTimeInfo.formatConf().formatStr(styleMap[style]);
};
exports.formatSimple = formatSimple;
/**
 * @deprecated
 */
var getTimeStamp = function (time) {
    var timeStr = typeof time === 'string' ? time.replace(/\-/g, '/') : time;
    var date = new Date(timeStr);
    var fakeTimeStamp = Date.parse(date);
    return (fakeTimeStamp / 1000) * 2 - (0, base_1.getOffsetTime)(fakeTimeStamp / 1000);
};
exports.getTimeStamp = getTimeStamp;
var startOf = function (timeStamp, units, startOf) {
    var isStartOf = typeof startOf !== 'undefined' ? startOf : true;
    var formatDate = (0, exports.getFormatTimeByPattern)(timeStamp, 'yyyy/MM/dd HH:mm:ss');
    var unit = (0, base_1.prettyUnit)(units);
    var date = new Date(formatDate);
    // 通过startOf参数来决定调整日期的方式
    // eslint-disable-next-line default-case
    switch (unit) {
        case 'week':
            date.setDate(date.getDate() - (isStartOf ? date.getDay() : date.getDay() - 6));
            break;
        case 'isoweek':
            var isoWeekday = date.getDay() || 7;
            date.setDate(date.getDate() - (isStartOf ? isoWeekday - 1 : isoWeekday - 7));
            break;
        case 'month':
            if (!isStartOf) {
                date.setMonth(date.getMonth() + 1);
            }
            date.setDate(isStartOf ? 1 : 0);
            break;
        case 'year':
            date.setMonth(isStartOf ? 0 : 11);
            date.setDate(isStartOf ? 1 : 31);
            break;
    }
    // 调整时间
    date.setHours(isStartOf ? 0 : 23, isStartOf ? 0 : 59, isStartOf ? 0 : 59);
    return (0, exports.getUTCTimeStamp)((0, base_1.cusFormatDate)(date), 'yyyy/MM/dd HH:mm:ss');
};
exports.startOf = startOf;
var endOf = function (timeStamp, units) {
    return (0, exports.startOf)(timeStamp, units, false);
};
exports.endOf = endOf;
var getDiffTime = function (dateStart, dateEnd, pattern, unit) {
    (0, helper_1.validateParam)(dateStart, 'dateStart');
    (0, helper_1.validateParam)(dateEnd, 'dateEnd');
    (0, helper_1.validateParam)(pattern, 'pattern');
    var stamp1 = (0, exports.getUTCTimeStamp)(dateStart, pattern);
    var stamp2 = (0, exports.getUTCTimeStamp)(dateEnd, pattern);
    var diffSecond = stamp2 - stamp1;
    (0, helper_1.validateParam)(diffSecond >= 0, 'time');
    var result = (0, base_1.getDiff)(diffSecond, unit);
    return result;
};
exports.getDiffTime = getDiffTime;
var getZeroTimeStamp = function (timeStamp) {
    (0, base_1.checkoutTimestamp)(timeStamp);
    var formatDate = (0, exports.getFormatTimeByPattern)(timeStamp, 'yyyy/MM/dd HH:mm:ss');
    var date = new Date(formatDate);
    // 时间归零
    date.setHours(0, 0, 0, 0);
    return (0, exports.getUTCTimeStamp)((0, base_1.cusFormatDate)(date), 'yyyy-MM-dd HH:mm:ss');
};
exports.getZeroTimeStamp = getZeroTimeStamp;
/**
 * @deprecated
 */
var getFormatTimeByBrowserTimezone = function (timeStamp, pattern) {
    (0, base_1.checkoutTimestamp)(timeStamp);
    var locale = (0, base_1.getBaseInfo)().locale;
    var amPmMarkers = (0, base_1.getFormat)(timeStamp).amPmMarkers;
    return (0, base_1.date2str)({
        locale: locale,
        timeStamp: timeStamp,
        pattern: pattern,
        amPmMarkers: amPmMarkers
    });
};
exports.getFormatTimeByBrowserTimezone = getFormatTimeByBrowserTimezone;
var getAddSubtractString = function (timeStamp, number, unit) {
    var date = new Date((0, exports.getFormatTimeByPattern)(timeStamp, 'yyyy/MM/dd HH:mm:ss'));
    var adjustDate = function (date, unit, number) {
        var adjustmentFunctions = {
            week: function (dt, num) { return date.setDate(dt.getDate() + 7 * num); },
            month: function (dt, num) { return date.setMonth(dt.getMonth() + num); },
            year: function (dt, num) { return date.setYear(dt.getFullYear() + num); },
            default: function (dt, num) { return date.setDate(dt.getDate() + num); }
        };
        return (adjustmentFunctions[unit] || adjustmentFunctions.default)(date, number);
    };
    adjustDate(date, unit, number);
    return (0, exports.getUTCTimeStamp)((0, base_1.cusFormatDate)(date), 'yyyy/MM/dd HH:mm:ss');
};
exports.getAddSubtractString = getAddSubtractString;
var add = function (timeStamp, number, units) {
    var curNumber = Number(number);
    var unit = (0, base_1.prettyUnit)(units);
    var minuteDuration = 60;
    var hourDuration = minuteDuration * 60;
    switch (unit) {
        case 'second':
            return timeStamp + curNumber;
        case 'minute':
            return timeStamp + curNumber * minuteDuration;
        case 'hour':
            return timeStamp + curNumber * hourDuration;
        default:
            return (0, exports.getAddSubtractString)(timeStamp, curNumber, unit);
    }
};
exports.add = add;
var subtract = function (timeStamp, number, units) {
    return (0, exports.add)(timeStamp, -1 * Number(number), units);
};
exports.subtract = subtract;
function setCity(cityId) {
    (0, base_1.initCity)(cityId);
}
exports.setCity = setCity;
function setTimezone(timezone) {
    (0, base_1.initTimezone)(timezone);
}
exports.setTimezone = setTimezone;
function getDiffByTimestamp(stampStart, stampEnd, unit) {
    if (!stampStart || !stampEnd || stampStart > stampEnd) {
        throw Error('Elvish Error: invalid time parameters');
    }
    var diffSecond = stampEnd - stampStart;
    var result = (0, base_1.getDiff)(diffSecond, unit);
    return result;
}
exports.getDiffByTimestamp = getDiffByTimestamp;
var getYearStartEnd = function (timeStamp) {
    return [(0, exports.startOf)(timeStamp, 'year'), (0, exports.startOf)(timeStamp, 'year', false)];
};
exports.getYearStartEnd = getYearStartEnd;
var getMonthStartEnd = function (timeStamp) {
    return [(0, exports.startOf)(timeStamp, 'month'), (0, exports.startOf)(timeStamp, 'month', false)];
};
exports.getMonthStartEnd = getMonthStartEnd;
var getWeekStartEnd = function (timeStamp, style) {
    var initCountry = (0, base_1.getInitCountry)();
    var isEgypt = initCountry === 'EG';
    var weekType = isEgypt ? 'week' : 'isoweek';
    var startTimeStamp = (0, exports.startOf)(timeStamp, weekType);
    var endTimeStamp = (0, exports.endOf)(timeStamp, weekType);
    if (style === 'TIMESTAMP') {
        return [startTimeStamp, endTimeStamp];
    }
    var formatPattern = 'yyyy/MM/dd HH:mm:ss';
    return [
        (0, exports.getFormatTimeByPattern)(startTimeStamp, formatPattern),
        (0, exports.getFormatTimeByPattern)(endTimeStamp, formatPattern)
    ];
};
exports.getWeekStartEnd = getWeekStartEnd;
